<div class="flex flex-col gap-6 w-full p-4">
    <h2 class="text-xl font-semibold text-center mt-4">{{ translateServ.dictionary['STEP_CONF_TITLE'] }}</h2>

    <p-toast></p-toast>

    <!-- Confirmation Message -->
    <div class="flex flex-col items-center justify-center p-6 bg-green-900 bg-opacity-30 rounded-lg shadow-lg border border-green-700">
        <i class="pi pi-check-circle text-green-500 text-6xl mb-4 animate-fadein"></i>
        <h3 class="text-2xl font-bold text-green-300 text-center mb-3">{{ translateServ.dictionary['STEP_CONF_TEXT'] }}</h3>
        <p class="text-lg text-green-200 text-center">
            {{ translateServ.dictionary['STEP_CONF_MSG'] }}
            <span class="font-semibold text-white">
                {{ entityType?.label || entityType || 'Entity' }},  {{ businessName || 'N/A' }} ({{ businessNumber || 'N/A' }})
            </span>?
        </p>
    </div>

    <!-- Navigation Buttons -->
    <div class="flex justify-between pt-6">
        <p-button
            label="{{ translateServ.dictionary['BACK'] }}"
            [icon]="dirServ.isRtl() ? 'pi pi-arrow-right' : 'pi pi-arrow-left'"
            [iconPos]="dirServ.isRtl() ? 'right' : 'left'"
            severity="secondary"
            (onClick)="prevStep.emit()">
        </p-button>
        <div class="flex gap-4">
            <p-button
                label="{{ translateServ.dictionary['PRE_BTN_CANCEL'] }}"
                icon="pi pi-times"
                severity="danger"
                (onClick)="cancelProcess()">
            </p-button>
            <p-button
                label="{{ translateServ.dictionary['PREV_BTN_SAVE'] }}"
                icon="pi pi-check"
                severity="success"
                (onClick)="completeProcess()">
            </p-button>
        </div>
    </div>
</div>
